import Vue from 'vue';
import VueRouter from 'vue-router';

// --- 组件导入 ---
import CustomerLogin from '../components/Login.vue';
import Register from '../components/Register.vue';
import Infomation from '../components/Infomation.vue';
import ProjectList from '../components/ProjectList.vue';
import ProjectCreate from '../components/ProjectCreate.vue';
import FileParser from '../components/FileParser.vue';
import MessageForm from '../components/MessageForm.vue';
import EmployeeList from '../components/EmployeeList.vue';
import MessageList from '../components/MessageList.vue';
import CustomerList from '../components/CustomerList.vue';
import ProjectStats from '../components/ProjectStats.vue';
import ProjectTarget from '../components/ProjectTarget.vue';
import ProjectSelector from '../components/ProjectSelector.vue';
import ProjectRange from "@/components/ProjectRange.vue";
import MediaList from "@/components/MediaList.vue";
import MediaStats from "@/components/MediaStats.vue";
import MediaCreate from "@/components/MediaCreate.vue";
import AppLayout from '../AppLayout.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/customer/login' },
  { path: '/customer/login', name: 'CustomerLogin', component: CustomerLogin },
  { path: '/register', name: 'Register', component: Register },
  {
    path: '/app',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'information', name: 'Information', component: Infomation },
      { path: 'projects', name: 'ProjectList', component: ProjectList },
      { path: 'projects/create', name: 'ProjectCreate', component: ProjectCreate },
      { path: 'parser', name: 'FileParser', component: FileParser },
      { path: 'message-form', name: 'MessageForm', component: MessageForm },
      { path: 'employees', name: 'EmployeeList', component: EmployeeList },
      { path: 'messages', name: 'MessageList', component: MessageList },
      { path: 'customers', name: 'CustomerList', component: CustomerList },
      { path: 'project-stats', name: 'ProjectStats', component: ProjectStats },
      { path: 'project-target', name: 'ProjectTarget', component: ProjectTarget },
      { path: 'project-range', name: 'ProjectRange', component: ProjectRange },
      { path: 'project-selector', name: 'ProjectSelector', component: ProjectSelector },
      { path: 'media', name: 'MediaList', component: MediaList },
      { path: 'media-stats', name: 'MediaStats', component: MediaStats },
      { path: 'media/create', name: 'MediaCreate', component: MediaCreate },
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 全局前置路由守卫
router.beforeEach((to, from, next) => {
  // 检查客户认证（localStorage方式）
  const customerUsername = localStorage.getItem('username');
  const customerRole = localStorage.getItem('userRole');
  const isCustomerLoggedIn = !!(customerUsername && customerRole === 'customer');
  
  const isLoggedIn = isCustomerLoggedIn;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // 访问需要权限的页面，但未登录
  if (requiresAuth && !isLoggedIn) {
    next({ name: 'CustomerLogin' });
    return;
  }

  // 已登录访问登录/注册页
  const loginRoutes = ['CustomerLogin', 'Register'];
  if (loginRoutes.includes(to.name) && isLoggedIn) {
    next({ name: 'Information' });
    return;
  }
  
  next();
});


export default router;